import { getValidationMessage } from '@gef-ui/localization/messages';
import validationMessages from '@gef-ui/localization/validationMessages';
import T from "ramda/es/T";
import allPass from "ramda/es/allPass";
import both from "ramda/es/both";
import compose from "ramda/es/compose";
import is from "ramda/es/is";
import isEmpty from "ramda/es/isEmpty";
import map from "ramda/es/map";
import not from "ramda/es/not";
import pick from "ramda/es/pick";
import alwaysNull from "ramda-extension/es/alwaysNull";
import isObject from "ramda-extension/es/isObject";
import isPromise from "ramda-extension/es/isPromise";
import { resolveFieldLabel } from '../../utils/fieldLabel';
import { baseValidationTypes } from '../constants';
import { isFilled, isSpecialValidation } from '../utils';
const notEmptyString = allPass([
    is(String),
    compose(not, isEmpty)
]);
const resolveValidationMessageCreator = (messageKey, options)=>{
    if (validationMessages[messageKey]) {
        return validationMessages[messageKey](options);
    }
    return getValidationMessage(messageKey, options);
};
const createValidationResult = ({ args, messageKeyFn, fnDefaults, type, other })=>(result)=>{
        const { messageKey, metaInfo = [], messageArgs = {} } = isObject(result) ? result : {
            messageKey: result
        };
        if (isSpecialValidation(type) && result === true || !notEmptyString(messageKey) && !isSpecialValidation(type)) {
            return null;
        }
        const fieldLabel = resolveFieldLabel(args.fieldDescriptor);
        const resolvedMessageKey = messageKeyFn(args) ?? messageKey;
        const options = {
            field: fieldLabel,
            ...fnDefaults?.defaultMessageArgs,
            ...args,
            ...other,
            ...messageArgs
        };
        return {
            type,
            result,
            errorMessage: resolveValidationMessageCreator(resolvedMessageKey, options),
            metaInfo: map(({ messageKey: metaMessageKey, messageKeyFn: metaMessageKeyFn = alwaysNull, ...otherMetaInfo })=>{
                const resolvedMetaMessageKey = metaMessageKeyFn(args) ?? metaMessageKey;
                return {
                    errorMessage: notEmptyString(resolvedMetaMessageKey) ? resolveValidationMessageCreator(resolvedMetaMessageKey, {
                        ...options,
                        ...otherMetaInfo,
                        fieldValueIndexed: options.fieldValue?.[otherMetaInfo.index]
                    }) : undefined,
                    ...otherMetaInfo
                };
            }, metaInfo),
            ...pick([
                'fieldIndices',
                'fieldRecord',
                'fieldName'
            ], args)
        };
    };
export default ((validationFn, fnDefaults)=>({ type = fnDefaults?.type || baseValidationTypes.ERROR, messageKeyFn = alwaysNull, when = T, nullable, ...other } = {})=>({
            type,
            validate: (args)=>{
                const getValidationResult = createValidationResult({
                    args,
                    messageKeyFn,
                    fnDefaults,
                    type,
                    other
                });
                const result = validationFn({
                    ...other,
                    ...fnDefaults?.defaultArgs
                })(args);
                if (isPromise(result) || other.async) {
                    return new Promise(async (resolve, reject)=>{
                        try {
                            resolve(getValidationResult(await result));
                        } catch (e) {
                            reject(e);
                        }
                    });
                }
                return getValidationResult(result);
            },
            when: nullable ? both(when, isFilled) : when,
            name: fnDefaults?.name,
            ...other
        }));
